import { render } from "./TheAposAdminBarMenu.vue?vue&type=template&id=019120b7&scoped=true"
import script from "./TheAposAdminBarMenu.vue?vue&type=script&lang=js"
export * from "./TheAposAdminBarMenu.vue?vue&type=script&lang=js"

import "./TheAposAdminBarMenu.vue?vue&type=style&index=0&id=019120b7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019120b7"],['__file',"admin-bar/ui/apos/components/TheAposAdminBarMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "019120b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('019120b7', __exports__)) {
    api.reload('019120b7', __exports__)
  }
  
  module.hot.accept("./TheAposAdminBarMenu.vue?vue&type=template&id=019120b7&scoped=true", () => {
    api.rerender('019120b7', render)
  })

}


export default __exports__